"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _avatar = _interopRequireDefault(require("@atlaskit/avatar"));
// https://atlaskit.atlassian.com/packages/core/avatar
var AvatarV2 = _avatar.default;
AvatarV2.displayName = 'AvatarV2';
var _default = exports.default = AvatarV2;
//# sourceMappingURL=AvatarV2.js.map